import React from "react"

import { FormRef } from "shared/types/ReactHookForm"
import { WithClassName } from "shared/types/WithClassName"

import { useMultiEditProductPositionFormViewModel } from "./model/useMultiEditProductPositionFormViewModel"
import {
  MultiEditProductPositionFormOptions,
  MultiEditProductPositionFormView
} from "./ui/MultiEditProductPositionFormView"

export interface MultiEditProductPositionFormData {
  productPosition: { quantity: number | null }
}

export interface MultiEditProductPositionFormProps extends WithClassName {
  id: string
  defaultFormData?: MultiEditProductPositionFormData
  formRef?: FormRef<MultiEditProductPositionFormData>
  isReadonly?: boolean

  options?: MultiEditProductPositionFormOptions

  onSubmit: (
    formData: MultiEditProductPositionFormData
  ) => Promise<unknown> | void
}

export const MultiEditProductPositionForm = React.memo(
  (props: MultiEditProductPositionFormProps) => (
    <MultiEditProductPositionFormView
      {...useMultiEditProductPositionFormViewModel(props)}
    />
  )
)
